import React from "react";
import { ArrowRight } from "lucide-react";

// Service Finance Company dealer credentials.
const SVCFIN_ACTION = "https://apply.svcfin.com/home/dealerAuthentication";
const DEALER_ID = "815129656";
const DEALER_KEY = "1742219857";

// Submits the dealer-authentication form as a top-level navigation, which loads
// the working Service Finance application. (Their form blocks iframe embedding,
// so a direct submit/redirect is used instead.)
const FinanceApply = ({ label = "Apply Online", className }) => {
  return (
    <form action={SVCFIN_ACTION} method="post" target="_blank" className="inline">
      <input type="hidden" name="id" value={DEALER_ID} />
      <input type="hidden" name="key" value={DEALER_KEY} />
      <button
        type="submit"
        className={
          className ||
          "inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangedark text-white font-semibold text-sm px-4 py-2.5 rounded-full shadow-md transition-all hover:-translate-y-0.5"
        }
      >
        {label}
        <ArrowRight className="w-4 h-4" />
      </button>
    </form>
  );
};

export default FinanceApply;
